import { categoryLinkForSubCategories } from "./common";

export const getCategoryFromSubCategory = (subCategory) => {
  return Object.keys(categoryLinkForSubCategories).find((categoryLink) => {
    return categoryLinkForSubCategories[categoryLink].includes(subCategory);
  });
};

export const encodeWithSearchParams = (value) => {
  const params = new URLSearchParams({ v: value });
  return params.toString().slice(2); // strip "v="
};
